<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <!-- 有数据 -->
        <div v-if="detailInfo != null">
          <div class="prediction">
            <div class="predictionBox flex flex-align-center" v-if="detailInfo.differDetail.hasOwnProperty('baseInfo')">
              <div class="title">Results</div>
              <ul class="flex list">
                <li>
                  <div class="topBox flex flex-pack-center flex-align-center" >
                    <i v-if="detailInfo.differDetail.baseInfo.hasOwnProperty('wdlHit') && detailInfo.differDetail.baseInfo.wdlHit == 1" class="active"></i>
                    <img v-if="detailInfo.differDetail.baseInfo.wdl != 2" class="teamLogo" :src="common.teamImgGet(detailInfo.differDetail.baseInfo.wdl == 1 ? detailInfo.match['homeTeam']['id'] : detailInfo.match['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
                    <span v-if="detailInfo.differDetail.baseInfo.wdl == 2">Draw&nbsp;</span>
                    <!-- {{detailInfo.differDetail.baseInfo.wdlRate}} -->
                  </div>
                  <div class="bottomBox">
                    <div class="odds">1 x 2</div>
                    
                  </div>
                </li>
                <li>
                  <div class="topBox flex flex-pack-center flex-align-center" >
                    <i v-if="detailInfo.differDetail.baseInfo.hasOwnProperty('ouHit') && detailInfo.differDetail.baseInfo.ouHit == 1" class="active"></i>
                    {{detailInfo.differDetail.overunderRes.predict == 1 ? 'Over' : 'Under'}} {{ detailInfo.differDetail.overunderRes.score }} {{ detailInfo.differDetail.overunderRes.predict > 1 ? 'Goals' : 'Goal' }}
                  </div>
                  <div class="bottomBox">
                    <div class="odds">O / U</div>
                  </div>
                </li>
                <li>
                  <div class="topBox flex flex-pack-center flex-align-center" >
                    <i v-if="detailInfo.differDetail.baseInfo.hasOwnProperty('ahHit') && detailInfo.differDetail.baseInfo.ahHit == 1" class="active"></i>
                    <img class="teamLogo" :src="common.teamImgGet(detailInfo.differDetail.baseInfo.ah == 1 ? detailInfo.match['homeTeam']['id'] : detailInfo.match['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
                    {{detailInfo.differDetail.baseInfo.ahVal}}
                  </div>
                  <div class="bottomBox">
                    <div class="odds">AH ({{detailInfo.differDetail.handicapRes.handicap}})</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="updateTimeBox">
              <div class="updateTime flex flex-align-center" @click="pupHistoryShow = !pupHistoryShow">
                {{getGameTime(detailInfo.differDetail.updateTime,'dd MM ,HH:mm')}}  Updated 
                <i class="icon"></i>
              </div>
            </div>
          </div>
          <!-- 已登录 -->
          <div class="logged" v-if="isLogin == true || match.state == 4" >
            <!-- 1X2 -->
            <div class="module" v-if="detailInfo.differDetail.hasOwnProperty('wplRes')">
              <div class="title">1x2 Prediction</div>
              <div class="box">
                <ul class="flex">
                  <li class="flex1">
                    <div class="head">Options</div>
                    <div class="body">1</div>
                    <div class="body">X</div>
                    <div class="body">2</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Calculated Probability</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.homeRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.drawRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.awayRes || '&nbsp;'}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Market View</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.compHomeRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.compDrawRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.wplRes.compAwayRes || '&nbsp;'}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Divergence Index</div>
                    <div class="body">{{Math.abs(detailInfo.differDetail.wplRes.homeDiff.split('%')[0])}}</div>
                    <div class="body">{{Math.abs(detailInfo.differDetail.wplRes.drawDiff.split('%')[0])}}</div>
                    <div class="body">{{Math.abs(detailInfo.differDetail.wplRes.awayDiff.split('%')[0])}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Suggestion</div>
                    <div class="suggestion" :class="detailInfo.differDetail.baseInfo.hasOwnProperty('wdlHit') && detailInfo.differDetail.baseInfo.wdlHit == 1 ? 'active' : ''">
                      {{detailInfo.differDetail.wplRes.predict == 1 ? 1 : (detailInfo.differDetail.wplRes.predict == 3 ? 2 : 'X')}}
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- OVER/UNDER -->
            <div class="module" v-if="detailInfo.differDetail.hasOwnProperty('overunderRes')">
              <div class="title">Goals Over/Under Prediction</div>
              <div class="box">
                <ul class="flex">
                  <li class="flex1">
                    <div class="head">Options</div>
                    <div class="body">Over</div>
                    <div class="body">Push</div>
                    <div class="body">Under</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Calculated Probability</div>
                    <div class="body">{{detailInfo.differDetail.overunderRes.overRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.overunderRes.evenRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.overunderRes.underRes || '&nbsp;'}}</div>
                  </li>
                  
                  <li class="flex1">
                    <div class="head">Suggestion</div>
                    <div class="suggestion" :class="detailInfo.differDetail.baseInfo.hasOwnProperty('ouHit') && detailInfo.differDetail.baseInfo.ouHit == 1 ? 'active' : ''">
                      {{detailInfo.differDetail.overunderRes.predict == 1 ? 'Over' : detailInfo.differDetail.overunderRes.predict == 2 ? 'Under' : 'Push'}}
                      ({{detailInfo.differDetail.overunderRes.score}})
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- AH -->
            <div class="module" v-if="detailInfo.differDetail.hasOwnProperty('handicapRes')">
              <div class="title">Asian Handicap Prediction</div>
              <div class="box">
                <ul class="flex">
                  <li class="flex1">
                    <div class="head">Options</div>
                    <div class="body">Home Win</div>
                    <div class="body">Push</div>
                    <div class="body">Away Win</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Calculated Probability</div>
                    <div class="body">{{detailInfo.differDetail.handicapRes.homeRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.handicapRes.evenRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.differDetail.handicapRes.awayRes || '&nbsp;'}}</div>
                  </li>
                  
                  <li class="flex1">
                    <div class="head">Suggestion</div>
                    <div class="suggestion" :class="detailInfo.differDetail.baseInfo.hasOwnProperty('ahHit') && detailInfo.differDetail.baseInfo.ahHit == 1 ? 'active' : ''">
                      {{detailInfo.differDetail.handicapRes.predict == 1 ? 'Home Win' : 'Away Win'}}
                      ({{detailInfo.differDetail.handicapRes.handicap}})
                      <!-- ({{detailInfo.differDetail.handicapRes.predict == 1 ? detailInfo.differDetail.handicapRes.home : detailInfo.differDetail.handicapRes.away}}) -->
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- last 10 matches -->
            <div class="module" v-if="detailInfo.differDetail.hasOwnProperty('last_10Goals') && JSON.stringify(detailInfo.differDetail.last_10Goals) != '{}'">
              <div class="title">Head-to-head stats for the last 10 matches</div>
              <div class="box">
                <div class="container">
                  <div class="flex flex-pack-justify">
                    <div class="homeTile"><span>{{ detailInfo.match.homeTeam.shortName }}</span> Home</div>
                    <div class="awayTile"><span>{{ detailInfo.match.awayTeam.shortName }}</span> Away</div>
                  </div>
                  <!-- 进球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.home.goals}}</div>
                      <div class="name">Goals Scored</div>
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.away.goals }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.differDetail.last_10Goals.home.goals) + Number(detailInfo.differDetail.last_10Goals.away.goals)), detailInfo.differDetail.last_10Goals.home.goals) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.differDetail.last_10Goals.home.goals) + Number(detailInfo.differDetail.last_10Goals.away.goals)), detailInfo.differDetail.last_10Goals.away.goals) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 失球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.home.loss }}</div>
                      <div class="name">Goals Conceded</div>
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.away.loss }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.differDetail.last_10Goals.home.loss) + Number(detailInfo.differDetail.last_10Goals.away.loss)), Number(detailInfo.differDetail.last_10Goals.home.loss)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.differDetail.last_10Goals.home.loss) + Number(detailInfo.differDetail.last_10Goals.away.loss)), Number(detailInfo.differDetail.last_10Goals.away.loss)) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 胜率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.home.winPct }}%</div>
                      <div class="name">Win Rate</div>
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.away.winPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.differDetail.last_10Goals.home.winPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.differDetail.last_10Goals.away.winPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 赢率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.home.handicapWinPct }}%</div>
                      <div class="name">Win Rate in AH</div>
                      <div class="val">{{ detailInfo.differDetail.last_10Goals.away.handicapWinPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.differDetail.last_10Goals.home.handicapWinPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.differDetail.last_10Goals.away.handicapWinPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 未登录 -->
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg3.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <!-- 无数据 -->
        <div v-else class="noData">
            <div><img src="../../../assets/images/nodata.png" /></div>
            <div class="title">No data</div>
          </div>
      </div>
      <div class="rightBox flex1">
        <div class="title">Additional Matches</div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime, 'dd MM YYYY,HH:mm')}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <van-popup class="popup" v-model="pupHistoryShow" :position="isWeb?'center':'bottom'" round  get-container="#app" >
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">Historical recommended records</p>
        <i class="popup_close" @click="pupHistoryShow = !pupHistoryShow"/>
      </div>
      <div class="popup_body">
        <div class="flex">
          <ul class="popup_body_tab flex">
            <li :class="logType == 'wpl_res' ? 'active' : ''" @click="changeLogType('wpl_res')">1x2</li>
            <li :class="logType == 'handicap_res' ? 'active' : ''" @click="changeLogType('handicap_res')">AH</li>
            <li :class="logType == 'overunder_res' ? 'active' : ''" @click="changeLogType('overunder_res')">O/U</li>
          </ul>
        </div>
        <ul class="popup_body_head flex">
          <li>Updated Time</li>
          <li>{{ logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 'Home' : 'Over' }}</li>
          <li>{{ logType == 'wpl_res' ? 'x' : logType == 'handicap_res' ? 'Handicap' : 'Total' }}</li>
          <li>{{ logType == 'wpl_res' ? 2 : logType == 'handicap_res' ? 'Away' : 'Under' }}</li>
        </ul>
        <ul class="list" v-if="logList != null">
          <li class="flex" v-for="(item,index) in logList[logType].logList" :key="index">
            <div v-if="isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd HH:mm')}}</div>
            <div v-if="!isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd')}}<br />{{getMatchTime(item.updateTime,'HH:mm')}}</div>
            <div :class="getPredict(item,1)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[0], logArr[0])}}</div>
            <div :class="getPredict(item,2)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[1], logArr[1])}}</div>
            <div :class="getPredict(item,3)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[2], logArr[2])}}</div>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data(){
    return {
      pupHistoryShow:false,
      isWeb: true,
      logType: 'wpl_res',
      logArr: ['home','draw','away']
    }
  },
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    logList: {
      type: [Array,Object],
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
    isLogin: {
      type: Boolean,
      default:false
    },
    setting: {
      type: Object,
      default: () => {}
    },
    match: {
      type: Object,
      default: () => {}
    },
  },
  methods:{
    getPredict(item,type){
      // item.value[3] == 3 ? 'active' : ''
      if(this.logType == 'wpl_res'){
        if(item.value[3] == type){
          return 'active'
        }
      }else if(this.logType == 'overunder_res'){
        if((item.value[3] == 1 && type == 1) || (item.value[3] == 2 && type == 3)){
          return 'active'
        }
      }else if(this.logType == 'handicap_res'){
        if((item.value[3] == 1 && type == 1) || (item.value[3] == 2 && type == 3)){
          return 'active'
        }
      }
    },
    // 关联比赛
    changeMatch(item){
      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    changeLogType(type){
      this.logType = type
      if(type == 'wpl_res'){
        this.logArr = ['home','draw','away']
      }else if(type == 'handicap_res'){
        this.logArr = ['home','hand','away']
      }else if(type == 'overunder_res'){
        this.logArr = ['over','total','under']
      }
    },  
    // 指数返回
    oddsCallFn(ot, val, type){
      let _val = val, _type = type;
      if(typeof(_val) == 'undefined'){
        return '-'
      }
      return this.oddsLuckyChange(ot, _val, _type);
    },

    // 赔率转换
    oddsLuckyChange(ot, val, type2){
      let _val = val, _form = this.setting.oddsFormRadio, _type = ot, _type2 = type2;
      let _typeArr = ['home', 'away', 'over', 'under'];

      // if(_type == 1){
      //   return this.common.oddsFromChange(_val, _form);
      // }
      
      if(_type == 2 || _type == 3){
        if(_typeArr.includes(_type2)){
          _val =  this.common.addValue(_val*1,1) - 1;
        }
      }
      if(_type2 == 'hand' || _type2 == 'total'){
        return _val;
      }

      return this.common.oddsFromChange(_val, _form);
    },


    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },
    
    // 获取更新时间
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },
    
    // 登录传参
    onChangePop(val) {
      let _val = val;
      this.$emit('onChangLogin', _val);
    },
    // 获取百分比
    percentageVal(a,b){
      return ((b/a) * 100) + '%'
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  watch:{
    logList(newVal, oldVal){
      console.log(newVal, oldVal)
    }
  },
}
</script>
<style scoped lang="less"> 
  @import 'divergence.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/divergence.vue